import { expect } from "@playwright/test";
import type { Locator } from "@playwright/test";

const baseUrl =
    process.env.TEST_SYSTEM_URL || "https://docs.ux.trumpf.com/iws/main";

export const getStoryUrl = (
    storyId: string,
    args?: Record<string, string | number | boolean>
): string => {
    const argsQuery = args
        ? Object.entries(args)
              .map(
                  ([key, value]) =>
                      `${key}:${
                          typeof value === "boolean" ? "!" : ""
                      }${encodeURIComponent(value)}`
              )
              .join(";")
        : "";
    return `${baseUrl}/iframe.html?id=${storyId}&viewMode=story&args=${argsQuery}`;
};

export const acceptCookies = async (page) => {
    await page.getByText("Accept all cookies", { exact: true }).click();
};

export const testArrayOfTextsToBeVisible = async (
    locator: Locator,
    keywords: string[]
) => {
    for (let i = 0; i < keywords.length; i++) {
        await expect(locator.getByText(keywords[i])).toBeVisible();
    }
};
